import { render, staticRenderFns } from "./workbenchFlowDetail.vue?vue&type=template&id=1f99b172&scoped=true"
import script from "./workbenchFlowDetail.vue?vue&type=script&lang=js"
export * from "./workbenchFlowDetail.vue?vue&type=script&lang=js"
import style0 from "./workbenchFlowDetail.vue?vue&type=style&index=0&id=1f99b172&prod&lang=scss&scoped=true"
import style1 from "./flowDetail.scss?vue&type=style&index=1&id=1f99b172&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99b172",
  null
  
)

export default component.exports